import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import './index.css'
import { AppShell } from './App'

const rootEl = document.getElementById('root')!

const app = (
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <AppShell />
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>
)

function shouldHydrate(root: HTMLElement): boolean {
  const meaningful = [...root.childNodes].some((node) => {
    if (node.nodeType === Node.ELEMENT_NODE) return true
    return node.nodeType === Node.TEXT_NODE && Boolean(node.textContent?.trim())
  })
  if (!meaningful) return false

  const prerendered = document.documentElement.dataset.prerenderPath
  if (!prerendered) return true

  const path = window.location.pathname.replace(/\/$/, '') || '/'
  return prerendered === path
}

// Hydrate only when this URL was prerendered. API-published kennisbank slugs
// are not in the build output; hydrating homepage HTML onto those routes crashes.
if (shouldHydrate(rootEl)) {
  hydrateRoot(rootEl, app)
} else {
  rootEl.replaceChildren()
  createRoot(rootEl).render(app)
}
